import React, { useEffect, useState } from 'react';
import Slider, { CustomArrowProps } from 'react-slick';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';

import { SvgIcon } from '@components/icon';
import { CustomText } from '@components/shared/common';
import { CalendarComponentProps } from '@models/common/calendar';
import { checkKeyEnterOrSpace, getDates } from '@utils/common';

import { CalenderButtonWrap } from './calendar.styled';

const SampleNextArrow = (props: CustomArrowProps) => {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style }}
      onClick={onClick}
      type="button"
    >
      <SvgIcon width="8" src="arrow-right-blue.svg" alt="Right Arrow" />
    </button>
  );
};

const SamplePrevArrow = (props: CustomArrowProps) => {
  const { className, style, onClick } = props;

  return (
    <button
      className={className}
      style={{ ...style }}
      onClick={onClick}
      type="button"
    >
      <SvgIcon width="8" src="arrow-left-blue.svg" alt="Left Arrow" />
    </button>
  );
};

const Calendar: React.FunctionComponent<CalendarComponentProps> = ({
  handleDateSelect,
  selectedDate,
}) => {
  const [slider, setSlider] = useState<any>();
  const dates = getDates();

  useEffect(() => {
    if (slider) {
      if (moment(selectedDate).isAfter(dates[7].formattedDate)) {
        slider?.slickPlay();
        setTimeout(() => {
          slider?.slickPause();
        }, 100);
      }
    }
  }, [slider, selectedDate]); //eslint-disable-line

  const onClick = (date: string) => (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.KeyboardEvent<HTMLButtonElement>,
  ) => {
    e.preventDefault();
    handleDateSelect(date);
  };

  const onKeyPress = (date: string) => (
    e: React.KeyboardEvent<HTMLButtonElement>,
  ) => {
    if (checkKeyEnterOrSpace(e)) {
      onClick(date)(e);
    }
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 7,
    accessibility: true,
    autoplaySpeed: 10,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <Slider ref={(sliderRef: Slider) => setSlider(sliderRef)} {...settings}>
      {dates.map(item => {
        const isSelectedDate = selectedDate === item.formattedDate;
        return (
          <div key={item.id}>
            <CalenderButtonWrap
              role="button"
              active={isSelectedDate}
              tabIndex={0}
              onClick={onClick(item.formattedDate)}
              onKeyPress={onKeyPress(item.formattedDate)}
            >
              <CustomText
                fSize="10.8px"
                fWeight="400"
                lSpacing="1.35px"
                lHeight="19px"
                align="center"
                transform="uppercase"
                mfWeight="400"
              >
                {item.day}
              </CustomText>
              <CustomText
                data-testid={`calendar-date-${item.date}`}
                fSize="27px"
                fWeight={isSelectedDate ? '400' : '200'}
                mfWeight={isSelectedDate ? '400' : '200'}
                lHeight="100%"
                align="center"
                pb="-4px"
              >
                {item.date}
              </CustomText>
            </CalenderButtonWrap>
          </div>
        );
      })}
    </Slider>
  );
};

export default Calendar;
